
<div :class="{'d-none': !isShown}">
  <div v-show="expandsHorizontally" class="hidden">
    <label ref="textCopy">{{displayText}}</label>
  </div>
  <textarea
    ref="textarea"
    :name="name"
    :id="id"
    v-bind="textareaBindings"
    v-model.sync="localValue"
    v-show="isShown"
    @click="emitClick"
    @blur="emitBlur"
    @mousedown="$emit('mousedown', $event)"
    :wrap="wrapVal"
    @keydown="handleKeydown"
    @paste="expandAndEmit($event, 'paste')"
    @keyup="expand"
    :placeholder="placeholder"
    :readonly="isReadOnly"
    :disabled="isDisabled || disabled"
    v-tooltip.wrap="tooltipIfDisabled"
    :maxlength="maxlength"
    rows="1"
    class="label skip-drag"
    :class="{ 'read-only' : isReadOnly, disabled: isDisabled }"
    :style="textareaStyle"
  ></textarea>
</div>
